import styled, { keyframes } from "styled-components";
import {
  QUERIES,
  SPACING,
  SPACING_RESPONSIVE,
  ANIMATION,
} from "../../../../../utils/constants";

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

export const SkeletonBox = styled.div<{ width?: string; height?: string }>`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "20px"};
  background: var(--gradient-skeleton);
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s ${ANIMATION.easing.easeInOut} infinite;
  border-radius: 4px;
`;

export const HeroCardSkeleton = styled.div`
  border-radius: 12px;
  background: var(--hero-background);
  border: 1px solid var(--color-card-border);
  box-shadow: var(--shadow-small);
  padding: ${SPACING_RESPONSIVE.mobile.cardPadding}px;

  @media ${QUERIES.tabletLargeAndUp} {
    padding: ${SPACING_RESPONSIVE.tablet.cardPadding}px;
  }

  @media ${QUERIES.laptopAndUp} {
    padding: ${SPACING_RESPONSIVE.desktop.cardPadding}px;
  }
`;

export const HeroGridSkeleton = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${SPACING.xl}px;

  @media ${QUERIES.tabletLargeAndUp} {
    grid-template-columns: 55fr 45fr;
    align-items: start;
  }
`;

export const HeroLeftSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
`;

export const StatsPanelSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  background: var(--color-card-background);
  border: 1px solid var(--color-card-border);
  border-radius: 10px;
  padding: ${SPACING.sm}px ${SPACING.md}px;
`;

export const StatRowSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${SPACING.md}px;
  padding: ${SPACING.md}px 0;

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-border);
  }
`;

export const ChartAreaSkeleton = styled(SkeletonBox)`
  height: 250px;

  @media ${QUERIES.tabletAndUp} {
    height: 300px;
  }
`;

export const RowsSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
`;

export const TransactionRowSkeleton = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.md}px;
`;

export const RecurringGridSkeleton = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${SPACING.sm}px;

  @media ${QUERIES.tabletLargeAndUp} {
    grid-template-columns: 1fr 1fr;
    gap: ${SPACING.md}px;
  }

  @media ${QUERIES.laptopAndUp} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const RecurringCardSkeleton = styled(SkeletonBox)`
  height: 72px;
  border-radius: 12px;
`;
